import { createRoot } from "react-dom/client";
import "@ingka/base/dist/style.css";
import "@ingka/variables/_light-mode.css";
import "@ingka/focus/dist/style.css";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/text/dist/style.css";
import "@ingka/pill/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/forms/dist/style.css";
import "@ingka/segmented-control/dist/style.css";
import "@ingka/loading/dist/style.css";
import "@ingka/skeleton/dist/style.css";
import "@ingka/tabs/dist/style.css";
import "@ingka/carousel/dist/style.css"; // @ingka/tabs uses carousel for overflow
import "@ingka/avatar/dist/style.css";
import "@ingka/modal/dist/style.css";
import "@ingka/aspect-ratio-box/dist/style.css";
import "@ingka/image/dist/style.css";
import "@ingka-group-digital/cwds-react-shared-tabs/style.css";
import "@ingka-group-digital/cwds-react-shared-modal/style.css";
import "@ingka-group-digital/cwds-react-user-profile/style.css";
import "@ingka-group-digital/cwds-react-header/style.css";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(<App />);
